import React from 'react';

/**
 * Standalone-viewer stub for the mapbox-gl address/map component.
 *
 * The real MapComponent (mapbox-gl + mapbox-gl-arcgis-featureserver) only
 * renders for address-verification fields behind a feature flag, which the
 * standalone viewer never enables. Stubbing it here keeps the heavy, native
 * mapbox-gl dependency out of the bundle. `input-text.js` is the only importer.
 */
const MapComponent = () => null;

export default MapComponent;
